// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./img/web_bkg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./img/web_light_bkg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./img/web_dark_bkg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================== General Styles ===================== */
html, body, #root {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden; /* prevent horizontal scroll */
}

.home-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
}

/* ===================== Navbar Styles ===================== */
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: rgba(0,0,0,0.5); /* semi-transparent */
}

.logo-img {
  height: 60px;
  width: auto;
}

.nav-button {
  background-color: transparent;
  color: #68edfc;
  border: 1px solid #facc15;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 12px;
  transition: all 0.3s ease;
}

.nav-button:hover {
  background-color: #facc15;
  color: #1e293b;
  box-shadow: 0px 2px 10px rgba(255, 204, 0, 0.4);
  cursor: pointer;
}

/* ===================== Menu Items ===================== */
.menu-items {
  display: flex;
}

.menu-items ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.menu-items ul li {
  margin: 0 15px;
}

.menu-items ul li a {
  color: white;
  text-decoration: none;
  font-size: 1rem;
  padding: 8px 12px;
  transition: background-color 0.3s;
}

.menu-items ul li a:hover {
  background-color: transparent;
}

/* ===================== Hamburger Menu ===================== */
.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;
  z-index: 1001;
}

.hamburger .bar {
  width: 30px;
  height: 4px;
  margin: 6px 0;
  background-color: white;
}

/* ===================== Dashboard Background ===================== */
.dashboard-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  display: flex;
  flex-direction: column;
}

/* Space for fixed navbar */
.outlet-wrapper {
  position: absolute;
  top: 100px; /* adjust based on navbar + hero section */
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* or 'center' if you want vertical centering */
  align-items: center;
}

/* Landing text styles */
.dashboard-content h1,
.dashboard-content h2 {
  color: white;
  text-shadow: 1px 1px 3px rgba(0,0,0,0.6);
}

/* ===================== Light & Dark Modes ===================== */

/* Light mode */
body.light-mode {
  background-color: #fdfdfd;
  color: #333;
}

body.light-mode .dashboard-content {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

body.light-mode .about-heading,
body.light-mode .about-subheading {
  color: #9b6201ff;
}

body.light-mode .about-text,
body.light-mode .about-list {
  color: #000;
}

/* Dark mode */
body.dark-mode {
  background-color: #1a1a1a;
  color: #f4f6f8;
}

body.dark-mode .dashboard-content {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

body.dark-mode .about-heading,
body.dark-mode .about-subheading {
  color: #FFD700; /* gold for dark mode headings */
}

body.dark-mode .about-text,
body.dark-mode .about-list {
  color: #ffffff;
}

/* ===================== About Us ===================== */
.about-us-container {
  padding: 40px;
  max-width: 900px;
  margin: auto;
  font-family: Arial, sans-serif;
  text-align: center;
}

.about-heading {
  font-size: 2.5rem;
  margin-bottom: 20px;
}

.about-subheading {
  font-size: 1.8rem;
  margin-top: 30px;
}

.about-text {
  font-size: 1.1rem;
  line-height: 1.8;
}

.about-list {
  font-size: 1.1rem;
  padding-left: 20px;
  line-height: 1.8;
  text-align: left;
}

/* ===================== Responsive ===================== */
@media (max-width: 768px) {
  .menu-items {
    display: none;
    flex-direction: column;
    position: absolute;
    top: 80px;
    left: 0;
    width: 100%;
    background-color: rgba(0,0,0,0.5);
  }

  .menu-items.active {
    display: flex;
  }

  .menu-items ul {
    display: block;
    text-align: center;
  }

  .menu-items ul li {
    margin: 10px 0;
  }

  .hamburger {
    display: flex;
  }
}

@media (max-width: 480px) {
  .navbar {
    padding: 10px;
    height: 70px;
  }

  .menu-items ul li a {
    font-size: 1rem;
  }
}
/* ================= Welcome Section ================= */
.home-welcome {
  text-align: center;
  margin-top: 20px;
}

.welcome-logo {
  width: 200px;
  margin-bottom: 20px;
}

/* Theme-aware welcome text */
.welcome-text {
  font-size: 2rem;       /* Adjust size as needed */
  font-weight: 600;
  margin: 0;
  color: inherit;        /* will follow body color (dark/light mode) */
  transition: color 0.3s ease;
}

/* Optional: customize colors per theme explicitly */
body.light-mode .welcome-text {
  color: #9b6201ff;      /* brown/goldish for light mode */
}

body.dark-mode .welcome-text {
  color: #FFD700;        /* gold for dark mode */
}
/* ================= Contact Us ================= */
.contact-us-wrapper {
  width: 100%;
  margin: 0 auto;
  padding: 50px 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.contact-us-container {
  max-width: 900px;
  font-family: Arial, sans-serif;
  text-align: center;
}

/* Headings */
.contact-heading {
  font-size: 2.5rem;
  margin-bottom: 20px;
  color: inherit; /* will follow theme */
}

/* Paragraph text */
.contact-text {
  font-size: 1.1rem;
  line-height: 1.8;
  color: inherit; /* theme-aware */
}

/* Contact details box */
.contact-details {
  text-align: left;
  margin-top: 40px;
  font-size: 1.1rem;
  line-height: 2;
  color: inherit; /* theme-aware */
}

.contact-link {
  color: #facc15;
  text-decoration: none;
}

.contact-link:hover {
  text-decoration: underline;
}

/* Theme-specific colors */
body.light-mode .contact-heading,
body.light-mode .contact-text,
body.light-mode .contact-details {
  color: #333;
}

body.dark-mode .contact-heading,
body.dark-mode .contact-text,
body.dark-mode .contact-details {
  color: #ffffff;
}
/* ===== Team Section ===== */
.team-wrapper {
  width: 100%;
  padding: 40px 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.team-container {
  max-width: 1000px;
  text-align: center;
  font-family: Arial, sans-serif;
}

.team-heading {
  font-size: 2.5rem;
  margin-bottom: 20px;
  color: inherit;
}

.team-intro {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 30px;
  color: inherit;
}

.team-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}

.team-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #1e293b;
  border-radius: 12px;
  padding: 15px;
  width: 100%;
  max-width: 400px;
  color: #fff;
  box-shadow: 0 4px 10px rgba(255, 204, 0, 0.2);
  transition: background-color 0.3s, color 0.3s;
}

.team-photo {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 15px;
  object-fit: cover;
}

.team-info {
  text-align: left;
}

.team-name {
  font-size: 18px;
  font-weight: bold;
  color: #facc15;
}

.team-role {
  font-size: 14px;
  font-weight: 600;
  color: #68edfc;
  margin: 2px 0;
}

.team-experience,
.team-bio {
  font-size: 12px;
  color: #2cde94;
  margin: 2px 0;
}

.loading-text {
  font-size: 1.2rem;
  text-align: center;
  color: inherit;
  margin-top: 20px;
}

/* ===== Light Mode Overrides ===== */
body.light-mode .team-card {
  background-color: #f4f4f4;
  color: #333;
}

body.light-mode .team-name {
  color: #9b6201ff;
}

body.light-mode .team-role {
  color: #333;
}

body.light-mode .team-bio {
  color: #333;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA,+DAA+D;AAC/D;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB,EAAE,8BAA8B;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,iCAAiC,EAAE,qBAAqB;AAC1D;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,+CAA+C;EAC/C,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA,qEAAqE;AACrE;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yDAA0C;EAC1C,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;EAClC,aAAa;EACb,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,UAAU,EAAE,0CAA0C;EACtD,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2BAA2B,EAAE,+CAA+C;EAC5E,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;;EAEE,YAAY;EACZ,wCAAwC;AAC1C;;AAEA,mEAAmE;;AAEnE,eAAe;AACf;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yDAAgD;AAClD;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA,cAAc;AACd;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yDAA+C;AACjD;;AAEA;;EAEE,cAAc,EAAE,gCAAgC;AAClD;;AAEA;;EAEE,cAAc;AAChB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;AACA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,eAAe,QAAQ,0BAA0B;EACjD,gBAAgB;EAChB,SAAS;EACT,cAAc,SAAS,6CAA6C;EACpE,2BAA2B;AAC7B;;AAEA,oDAAoD;AACpD;EACE,gBAAgB,OAAO,iCAAiC;AAC1D;;AAEA;EACE,cAAc,SAAS,uBAAuB;AAChD;AACA,mDAAmD;AACnD;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc,EAAE,sBAAsB;AACxC;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc,EAAE,gBAAgB;AAClC;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,cAAc,EAAE,gBAAgB;AAClC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;;;EAGE,WAAW;AACb;;AAEA;;;EAGE,cAAc;AAChB;AACA,6BAA6B;AAC7B;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,6CAA6C;EAC7C,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb","sourcesContent":["/* ===================== General Styles ===================== */\r\nhtml, body, #root {\r\n  height: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  overflow-x: hidden; /* prevent horizontal scroll */\r\n}\r\n\r\n.home-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100vh;\r\n  width: 100%;\r\n}\r\n\r\n/* ===================== Navbar Styles ===================== */\r\n.navbar {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px;\r\n  height: 60px;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  z-index: 1000;\r\n  background-color: rgba(0,0,0,0.5); /* semi-transparent */\r\n}\r\n\r\n.logo-img {\r\n  height: 60px;\r\n  width: auto;\r\n}\r\n\r\n.nav-button {\r\n  background-color: transparent;\r\n  color: #68edfc;\r\n  border: 1px solid #facc15;\r\n  padding: 8px 16px;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  font-size: 12px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.nav-button:hover {\r\n  background-color: #facc15;\r\n  color: #1e293b;\r\n  box-shadow: 0px 2px 10px rgba(255, 204, 0, 0.4);\r\n  cursor: pointer;\r\n}\r\n\r\n/* ===================== Menu Items ===================== */\r\n.menu-items {\r\n  display: flex;\r\n}\r\n\r\n.menu-items ul {\r\n  display: flex;\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.menu-items ul li {\r\n  margin: 0 15px;\r\n}\r\n\r\n.menu-items ul li a {\r\n  color: white;\r\n  text-decoration: none;\r\n  font-size: 1rem;\r\n  padding: 8px 12px;\r\n  transition: background-color 0.3s;\r\n}\r\n\r\n.menu-items ul li a:hover {\r\n  background-color: transparent;\r\n}\r\n\r\n/* ===================== Hamburger Menu ===================== */\r\n.hamburger {\r\n  display: none;\r\n  flex-direction: column;\r\n  cursor: pointer;\r\n  z-index: 1001;\r\n}\r\n\r\n.hamburger .bar {\r\n  width: 30px;\r\n  height: 4px;\r\n  margin: 6px 0;\r\n  background-color: white;\r\n}\r\n\r\n/* ===================== Dashboard Background ===================== */\r\n.dashboard-content {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-image: url('./img/web_bkg.jpg');\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n  background-position: center center;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* Space for fixed navbar */\r\n.outlet-wrapper {\r\n  position: absolute;\r\n  top: 100px; /* adjust based on navbar + hero section */\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start; /* or 'center' if you want vertical centering */\r\n  align-items: center;\r\n}\r\n\r\n/* Landing text styles */\r\n.dashboard-content h1,\r\n.dashboard-content h2 {\r\n  color: white;\r\n  text-shadow: 1px 1px 3px rgba(0,0,0,0.6);\r\n}\r\n\r\n/* ===================== Light & Dark Modes ===================== */\r\n\r\n/* Light mode */\r\nbody.light-mode {\r\n  background-color: #fdfdfd;\r\n  color: #333;\r\n}\r\n\r\nbody.light-mode .dashboard-content {\r\n  background-image: url('./img/web_light_bkg.png');\r\n}\r\n\r\nbody.light-mode .about-heading,\r\nbody.light-mode .about-subheading {\r\n  color: #9b6201ff;\r\n}\r\n\r\nbody.light-mode .about-text,\r\nbody.light-mode .about-list {\r\n  color: #000;\r\n}\r\n\r\n/* Dark mode */\r\nbody.dark-mode {\r\n  background-color: #1a1a1a;\r\n  color: #f4f6f8;\r\n}\r\n\r\nbody.dark-mode .dashboard-content {\r\n  background-image: url('./img/web_dark_bkg.png');\r\n}\r\n\r\nbody.dark-mode .about-heading,\r\nbody.dark-mode .about-subheading {\r\n  color: #FFD700; /* gold for dark mode headings */\r\n}\r\n\r\nbody.dark-mode .about-text,\r\nbody.dark-mode .about-list {\r\n  color: #ffffff;\r\n}\r\n\r\n/* ===================== About Us ===================== */\r\n.about-us-container {\r\n  padding: 40px;\r\n  max-width: 900px;\r\n  margin: auto;\r\n  font-family: Arial, sans-serif;\r\n  text-align: center;\r\n}\r\n\r\n.about-heading {\r\n  font-size: 2.5rem;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.about-subheading {\r\n  font-size: 1.8rem;\r\n  margin-top: 30px;\r\n}\r\n\r\n.about-text {\r\n  font-size: 1.1rem;\r\n  line-height: 1.8;\r\n}\r\n\r\n.about-list {\r\n  font-size: 1.1rem;\r\n  padding-left: 20px;\r\n  line-height: 1.8;\r\n  text-align: left;\r\n}\r\n\r\n/* ===================== Responsive ===================== */\r\n@media (max-width: 768px) {\r\n  .menu-items {\r\n    display: none;\r\n    flex-direction: column;\r\n    position: absolute;\r\n    top: 80px;\r\n    left: 0;\r\n    width: 100%;\r\n    background-color: rgba(0,0,0,0.5);\r\n  }\r\n\r\n  .menu-items.active {\r\n    display: flex;\r\n  }\r\n\r\n  .menu-items ul {\r\n    display: block;\r\n    text-align: center;\r\n  }\r\n\r\n  .menu-items ul li {\r\n    margin: 10px 0;\r\n  }\r\n\r\n  .hamburger {\r\n    display: flex;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .navbar {\r\n    padding: 10px;\r\n    height: 70px;\r\n  }\r\n\r\n  .menu-items ul li a {\r\n    font-size: 1rem;\r\n  }\r\n}\r\n/* ================= Welcome Section ================= */\r\n.home-welcome {\r\n  text-align: center;\r\n  margin-top: 20px;\r\n}\r\n\r\n.welcome-logo {\r\n  width: 200px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n/* Theme-aware welcome text */\r\n.welcome-text {\r\n  font-size: 2rem;       /* Adjust size as needed */\r\n  font-weight: 600;\r\n  margin: 0;\r\n  color: inherit;        /* will follow body color (dark/light mode) */\r\n  transition: color 0.3s ease;\r\n}\r\n\r\n/* Optional: customize colors per theme explicitly */\r\nbody.light-mode .welcome-text {\r\n  color: #9b6201ff;      /* brown/goldish for light mode */\r\n}\r\n\r\nbody.dark-mode .welcome-text {\r\n  color: #FFD700;        /* gold for dark mode */\r\n}\r\n/* ================= Contact Us ================= */\r\n.contact-us-wrapper {\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  padding: 50px 20px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n}\r\n\r\n.contact-us-container {\r\n  max-width: 900px;\r\n  font-family: Arial, sans-serif;\r\n  text-align: center;\r\n}\r\n\r\n/* Headings */\r\n.contact-heading {\r\n  font-size: 2.5rem;\r\n  margin-bottom: 20px;\r\n  color: inherit; /* will follow theme */\r\n}\r\n\r\n/* Paragraph text */\r\n.contact-text {\r\n  font-size: 1.1rem;\r\n  line-height: 1.8;\r\n  color: inherit; /* theme-aware */\r\n}\r\n\r\n/* Contact details box */\r\n.contact-details {\r\n  text-align: left;\r\n  margin-top: 40px;\r\n  font-size: 1.1rem;\r\n  line-height: 2;\r\n  color: inherit; /* theme-aware */\r\n}\r\n\r\n.contact-link {\r\n  color: #facc15;\r\n  text-decoration: none;\r\n}\r\n\r\n.contact-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Theme-specific colors */\r\nbody.light-mode .contact-heading,\r\nbody.light-mode .contact-text,\r\nbody.light-mode .contact-details {\r\n  color: #333;\r\n}\r\n\r\nbody.dark-mode .contact-heading,\r\nbody.dark-mode .contact-text,\r\nbody.dark-mode .contact-details {\r\n  color: #ffffff;\r\n}\r\n/* ===== Team Section ===== */\r\n.team-wrapper {\r\n  width: 100%;\r\n  padding: 40px 20px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n}\r\n\r\n.team-container {\r\n  max-width: 1000px;\r\n  text-align: center;\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\n.team-heading {\r\n  font-size: 2.5rem;\r\n  margin-bottom: 20px;\r\n  color: inherit;\r\n}\r\n\r\n.team-intro {\r\n  font-size: 1.1rem;\r\n  line-height: 1.8;\r\n  margin-bottom: 30px;\r\n  color: inherit;\r\n}\r\n\r\n.team-grid {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 20px;\r\n  justify-content: center;\r\n}\r\n\r\n.team-card {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  background-color: #1e293b;\r\n  border-radius: 12px;\r\n  padding: 15px;\r\n  width: 100%;\r\n  max-width: 400px;\r\n  color: #fff;\r\n  box-shadow: 0 4px 10px rgba(255, 204, 0, 0.2);\r\n  transition: background-color 0.3s, color 0.3s;\r\n}\r\n\r\n.team-photo {\r\n  width: 80px;\r\n  height: 80px;\r\n  border-radius: 50%;\r\n  margin-right: 15px;\r\n  object-fit: cover;\r\n}\r\n\r\n.team-info {\r\n  text-align: left;\r\n}\r\n\r\n.team-name {\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  color: #facc15;\r\n}\r\n\r\n.team-role {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #68edfc;\r\n  margin: 2px 0;\r\n}\r\n\r\n.team-experience,\r\n.team-bio {\r\n  font-size: 12px;\r\n  color: #2cde94;\r\n  margin: 2px 0;\r\n}\r\n\r\n.loading-text {\r\n  font-size: 1.2rem;\r\n  text-align: center;\r\n  color: inherit;\r\n  margin-top: 20px;\r\n}\r\n\r\n/* ===== Light Mode Overrides ===== */\r\nbody.light-mode .team-card {\r\n  background-color: #f4f4f4;\r\n  color: #333;\r\n}\r\n\r\nbody.light-mode .team-name {\r\n  color: #9b6201ff;\r\n}\r\n\r\nbody.light-mode .team-role {\r\n  color: #333;\r\n}\r\n\r\nbody.light-mode .team-bio {\r\n  color: #333;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
